import { StyleDeclaration, StyleSheet, css } from 'aphrodite';
import * as React from 'react';
import { brandPrimary } from '../../../styles/colors';
import { baseStyleSheet as bs } from '../../../styles/styles';
import { TextMessageTail } from '../../svgs/icons/TextMessageTail';

const styleSheet = StyleSheet.create({
	tailSent: {
		right: -7,
	},
});

export function OutboundTextMessageBubble({
	styleDeclarations = [],
	children,
	backgroundColor = brandPrimary,
}: {
	styleDeclarations?: StyleDeclaration[];
	children: React.ReactNode;
	backgroundColor: string;
}) {
	return (
		<div
			className={css(
				bs.rounded2xl,
				bs.inlineBlock,
				bs.textXs,
				bs.py4,
				bs.px6,
				bs.relative,
				bs.whiteSpacePreWrap,
				bs.breakWord,
				bs.textWhite,
				...styleDeclarations
			)}
			style={{ backgroundColor }}
		>
			{children}
			<TextMessageTail className={css(bs.absolute, bs.bottom0, styleSheet.tailSent)} color={backgroundColor} />
		</div>
	);
}
